import { render } from "./dropdown-nav-datasets.vue?vue&type=template&id=06553d25"
import script from "./dropdown-nav-datasets.vue?vue&type=script&lang=js"
export * from "./dropdown-nav-datasets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__